<template>
  <div
    class="block w-full overflow-hidden bg-white rounded shadow cursor-pointer"
    @click="openVideo"
  >
    <div
      ref="thumb"
      class="relative flex flex-col items-center justify-center video-card-height"
    >
      <img :src="thumbnail" class="absolute w-full h-full object-cover" />
      <img
        src="https://cdn.sportsrecruits.com/assets/itg/play-button-white-blue.svg"
        class="absolute w-14 h-14"
      >
    </div>
    <div class="p-3">
      <div class="mb-2 ds-text-base font-medium text-gray-900 truncate">
        {{ title }}
      </div>

      <div class="flex flex-row justify-between">
        <div class="m-0 ds-text-xs font-normal text-gray-700">
          <template v-if="views">
            {{ views }} Views •
          </template>
          {{ date }}
        </div>
        <div class="m-0 ds-text-xs font-medium text-gray-800">
          {{ duration }}
        </div>
      </div>
    </div>

    <VideoModal
      :show="showVideo"
      :video="video"
      @close="closeVideo()"
    />
  </div>
</template>

<script>
import VideoModal from "@/components/VideoModal/Modal";
import moment from "moment";
import getUrlParameter from '../../../../../../../js/utils/getUrlParameter';

export default {
    components: { VideoModal },

    props: {
        video: { type: Object, required: true },
    },

    data() {
        const isInUrl = getUrlParameter('video') == this.video.id

        return {
            showVideo: isInUrl,
        };
    },

    computed: {
        title() {
            return this.video.name;
        },

        views() {
            return this.video.viewCount;
        },

        date() {
            return moment(this.video.createdDate).format("MMM D, YYYY");
        },

        duration() {
            return this.video.duration;
        },

        thumbnail() {
            return this.video.thumbnailUrl;
        },
    },
    async mounted() {
        //  This code is in place to help preserve a 16:9 aspect ratio for the thumbnails as requested by the design team.
        let self = this;
        let vidCard, width;
        let counter = 0;
        // Make sure the cards have been mounted and widths calculated to properly calculate width. (without, width is 0 if videos load too fast)
        let t = setInterval(()=> {
            if (width || counter === 200) {
                window.clearInterval(t);
            }
            counter++;
            vidCard = document.querySelector('.video-card-height') || { clientWidth: 0 };
            width = vidCard.clientWidth;
            // set CSS variable with video card width on mount
            self.$el.style.setProperty('--vid-card-width', vidCard.offsetWidth + 'px');
        },30);

        // listen for browser resize and update the variable with the new width
        window.addEventListener('resize', () => {
            window.requestAnimationFrame(() => {
                self.$el.style.setProperty('--vid-card-width', vidCard.offsetWidth + 'px');
            });
        });
    },
    methods: {
        openVideo() {
            this.showVideo = true;
        },

        closeVideo() {
            this.showVideo = false;
        },
    },
};
</script>

<style lang="scss" scoped>
  /* Trick for allowing divs with background-images to maintain a certain height (you just can't set the height property, i've tried)  This is known trick.  */
  .video-card-height {
    &:after {
      content: "";
      display: block;
      height: 0;
      width: 0;
      padding-bottom: calc((var(--vid-card-width) / 16) * 9);
    }
  }
</style>
